import { ReactNode } from 'react'

import { Helmet } from 'react-helmet-async'

import {
  Box, Columns,
} from '@domain-group/suit-theme'

import PageHeader from '@components/PageHeader'

import { UseCampaignPayload } from '@hooks/useCampaign'
import useCurrentUser from '@hooks/useCurrentUser'

import PublishCampaignButton from '@components/PublishCampaignButton'

import { getCampaignPermissions, getCampaignType } from 'shared/functions/campaign'

import propertyDetailsTabBarItems from '@sections/Client/packs/Campaign/utils/generatePropertyDetailsTabBarItems'

interface PageLayoutProps {
  campaignPayload: UseCampaignPayload,
  children: ReactNode,
}

const PageLayout = (props: PageLayoutProps) => {
  const { children, campaignPayload } = props

  const {
    campaign, campaign: { address, id },
  } = campaignPayload

  const { currentUser } = useCurrentUser()

  const campaignPermissions = getCampaignPermissions({ user: currentUser, campaignType: getCampaignType(campaign) })

  return (
    <>
      <Helmet>
        <title>{address || 'Campaign'} | Portal Data</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <PublishCampaignButton campaignPayload={campaignPayload} />
        )}
        activeTabBarItemKey="portal-data"
        boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
        nestedNavigation
        tabBarItems={propertyDetailsTabBarItems(id, campaignPermissions)}
        title="Portal Data"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
